import { render } from "./ResourceAction.vue?vue&type=template&id=14307ac8"
import script from "./ResourceAction.vue?vue&type=script&lang=js"
export * from "./ResourceAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__